import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserRole } from 'src/app/common/state/user/role/user-role';
import { User } from 'src/app/common/state/user/user.model';
import { UserState } from 'src/app/common/state/user/user.state';
import { checkIfPlanEditor } from 'src/app/private/pages/plans-page/plans-page-helpers';
import { PlanDetailsItemStateModel } from '../../../state/implementation-plan/implementation-plan.state';
import { PlansAPIResponse } from '../../../types/responses/plan.responses';

@Component({
  selector: 'app-plans-subnav',
  templateUrl: './plans-subnav.component.html',
  standalone: false,
})
export class PlansSubNavComponent implements OnChanges {
  user: User;

  planEditor = false;

  canSeeStatusReports = false;

  @Input() plan: PlansAPIResponse | PlanDetailsItemStateModel;

  constructor(private store: Store) {
    this.user = this.store.selectSnapshot(UserState.getUser) as User;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('plan' in changes && this.plan && this.user) {
      this.planEditor = checkIfPlanEditor(this.user, this.plan);
      this.canSeeStatusReports =
        this.planEditor || this.user.roles.includes(UserRole.DISTRICT_ADMIN);
    }
  }
}
